import { render } from "./Wallet.vue?vue&type=template&id=6dbb0c53"
const script = {}
script.render = render

export default script